import React from 'react';
import styles from './restrictionBlock.module.css';
import { renderRich } from './RichTextEditor';
import { useDialog } from '../../hooks/useFocusTrap';

export interface RestrictionInfo {
  restriction: true;
  title:       string;
  comment:     string | null;
  expires_at:  string | null;
}

interface Props {
  data:    RestrictionInfo;
  onClose: () => void;
}

export default function RestrictionBlock({ data, onClose }: Props) {
  const expiryStr = data.expires_at
    ? (() => {
        const s = data.expires_at;
        const d = (!s.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(s)) ? new Date(s + 'Z') : new Date(s);
        return d.toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' });
      })()
    : null;

  // Escape, удержание фокуса и возврат его на кнопку, открывшую окно
  const dialogRef = React.useRef<HTMLDivElement>(null);
  useDialog(dialogRef, onClose);
  const titleId = React.useId();

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}
        ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1}>
        <div className={styles.modalAccent} />

        <div className={styles.header}>
          <span id={titleId} className={styles.title}>🔒 {data.title}</span>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Закрыть">✕</button>
        </div>

        {data.comment && (
          <>
            <div className={styles.divider} />
            <div
              className={styles.comment}
              dangerouslySetInnerHTML={{ __html: renderRich(data.comment) }}
            />
          </>
        )}

        <div className={styles.divider} />
        <div className={styles.expiry}>
          {expiryStr
            ? <>⏳ Действует до: <strong>{expiryStr}</strong></>
            : <>♾ Бессрочно</>
          }
        </div>

        <div className={styles.footer}>
          <button className={styles.okBtn} onClick={onClose}>Понятно</button>
        </div>
      </div>
    </div>
  );
}
